import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import Breadcrumb from '../common/Breadcrumb';
import ToolCard from '../common/ToolCard';
import toolsConfig from '../../config/tools';

/**
 * Tools Landing Page
 * Lists all available tools
 */
const ToolsMain = () => {
  // Convert tools config to array for rendering
  const tools = Object.values(toolsConfig.tools).map(tool => ({
    title: tool.title,
    description: tool.shortDescription,
    path: tool.path,
    tech: tool.tech
  }));

  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: 'Tools', path: '/tools' }
  ];

  return (
    <>
      <Helmet>
        <title>{toolsConfig.landing.title} | Elliot Koss</title>
        <meta name="description" content={toolsConfig.landing.description} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Container style={{ paddingTop: '100px', paddingBottom: '2rem' }}>
        <Breadcrumb items={breadcrumbItems} />
        <Row className="mb-4">
          <Col>
            <h1>{toolsConfig.landing.title}</h1>
            <p className="text-muted">{toolsConfig.landing.subtitle}</p>
          </Col>
        </Row>
        <Row>
          {tools.map((tool, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <ToolCard tool={tool} />
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default ToolsMain;
